export const URL = "https://bmbcpc.com";
export const API_URL = "https://bmbcpc-api.herokuapp.com/api/v1/";
export const staging_URL = "localhost:8000/api/v1/";
export const SITEURL = "https://www.bmbcpc.com";
